import React, { memo, useCallback } from "react";
import { ReactComponent as SelectIcon } from "Components/common/assets/selectIconBold.svg";
import { ZoneSelectorButtonStyled } from "./styles";

// ============================================================================
// Types
// ============================================================================

export interface ZoneSelectorButtonProps {
  isActive: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

// ============================================================================
// Component
// ============================================================================

export const ZoneSelectorButton = memo<ZoneSelectorButtonProps>(
  ({ isActive, onClick }) => {
    const handleClick = useCallback(
      (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(e);
      },
      [onClick]
    );

    return (
      <ZoneSelectorButtonStyled
        type="button"
        onClick={handleClick}
        active={isActive}
      >
        <SelectIcon />
      </ZoneSelectorButtonStyled>
    );
  }
);

ZoneSelectorButton.displayName = "ZoneSelectorButton";
